export default {
    loading: "Caricamento"
}